// extracted by mini-css-extract-plugin
module.exports = {"center":"TextAlign_center__1U6RG","justify":"TextAlign_justify__29g8B","left":"TextAlign_left__3EczS","right":"TextAlign_right__1k97C"};